export default {
  name: 'Convention Center',
  filters: {
    region: 'Region',
    all: 'All',
    china: 'China',
    nation: 'Country',
    more: 'More',
    packUp: 'Pack up'
  },
  total: 'Total',
  stripStadium: ' stadiums',
  recommendedExhibition: 'Recommended Exhibitions',
  more: 'More',
  countryAndRegion: 'Country and Region',
  pavilionAddress: 'Venue Address',
  pavilionArea: 'Venue Area',
  squareMeter: '㎡'
}
